<template>
<div class="chapter">
<div class="inner_page">
<div class="body"><p class="ht">M<span class="smallcaps">URDER</span></p>
<p class="ht1"><em>on the</em></p>
<p class="ht2">C<span class="smallcaps">LIFFS</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// halftitlepage.vue?39acc516